// Content engine (Phase 3): Plan is the home (the quarterly ritual),
// Board tracks in-flight production with time-on-move, Ideas is the
// ranked backlog, Performance is the published scorecard. ?tab= deep-links
// a specific tab (This Week tasks land on the board).

import { useSearchParams } from 'react-router-dom';
import PlanView from '../content/PlanView';
import BoardView from '../content/BoardView';
import IdeasView from '../content/IdeasView';
import PerformanceView from '../content/PerformanceView';
import { quarterOf } from '../stages';

const TABS = [
  { id: 'plan', label: () => `Plan · ${quarterOf().split('-')[1]}` },
  { id: 'board', label: () => 'Production board' },
  { id: 'ideas', label: () => 'Idea bank' },
  { id: 'performance', label: () => 'Performance' },
];

export default function ContentView() {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab');
  const tab = TABS.some(t => t.id === requested) ? requested : 'plan';
  const setTab = (id) => setParams(id === 'plan' ? {} : { tab: id }, { replace: true });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <div className="flex gap-1 bg-white border border-line rounded-[9px] p-[3px] w-max">
          {TABS.map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`text-[12.5px] font-bold px-3.5 py-1.5 rounded-[6px] transition-colors ${
                tab === t.id ? 'bg-deep-teal text-white' : 'text-ink-2 hover:text-navy'
              }`}
            >
              {t.label()}
            </button>
          ))}
        </div>
        <span className="text-ink-3 text-[12px]">The schedule here feeds "This Week" on the dashboard</span>
      </div>

      {tab === 'plan' && <PlanView />}
      {tab === 'board' && <BoardView />}
      {tab === 'ideas' && <IdeasView />}
      {tab === 'performance' && <PerformanceView />}
    </div>
  );
}
